<template>
	<div>
		<a-table :columns="columns" :dataSource="data">
			<template slot="action" slot-scope="record">
				<a-popconfirm title="你确定要删除这个客服吗?" @confirm="confirm(record.key)" @cancel="cancel(record.key)" okText="Yes" cancelText="No">
					<a href="#">删除</a>
				</a-popconfirm>
			</template>
			<p slot-scope="record" style="margin: 0">{{ record.description }}</p>
		</a-table>

		<a-button class="editable-add-btn" type="primary" @click="handleAdd">添加客服</a-button>
		<a-modal title="Title" :visible="visible" @ok="handleOk" :confirmLoading="confirmLoading" @cancel="handleCancel">
			<a-form :form="form">
				<a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="姓名">
					<a-input v-decorator="['username', { rules: [{ required: true, message: '请输入姓名' }] }]" placeholder="请输入姓名" />
				</a-form-item>
				<a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="电话">
					<a-input v-decorator="['phone', { rules: [{ required: checkNick, message: '请输入电话' }] }]" placeholder="请输入电话" />
				</a-form-item>
			</a-form>
		</a-modal>
	</div>
</template>
<script>
const columns = [
	{ title: '姓名', dataIndex: 'serviceName', key: 'serviceName', width: '150px' },
	{ title: '电话', dataIndex: 'servicePhone', key: 'servicePhone', width: '150px' },
	{ title: '操作', dataIndex: '', key: 'x', scopedSlots: { customRender: 'action' } }
];

const data = [{ key: 2, serviceName: '123', servicePhone: '18507031438' }, { key: 3, serviceName: '123', servicePhone: '19806506548' }];

const formItemLayout = {
	labelCol: { span: 4 },
	wrapperCol: { span: 8 }
};
const formTailLayout = {
	labelCol: { span: 4 },
	wrapperCol: { span: 8, offset: 4 }
};

export default {
	data() {
		return {
			data,
			columns,
			visible: false,
			confirmLoading: false,
			checkNick: false,
			formItemLayout,
			formTailLayout,
			form: this.$form.createForm(this, { name: 'dynamic_rule' })
		};
	},
	methods: {
		handleAdd() {
			this.visible = true;
		},
		confirm(e) {
			console.log(e);
			this.$message.success('Click on Yes');
		},
		cancel(e) {
			console.log(e);
			this.$message.error('Click on No');
		},
		showModal() {
			this.visible = true;
		},
		handleOk(e) {
			this.checkNick = e.target.checked;
			console.log(this.form.getFieldsValue())
			this.form.validateFields(err => {
				if (!err) {
					console.info('success');
				}else{
					return
				}
			});
			this.ModalText = 'The modal will be closed after two seconds';
			this.confirmLoading = true;
			setTimeout(() => {
				this.visible = false;
				this.confirmLoading = false;
			}, 2000);
		},
		handleCancel(e) {
			console.log('Clicked cancel button');
			this.visible = false;
		}
	}
};
</script>
<style>
.editable-add-btn {
	margin-bottom: 8px;
}
</style>
